import { render, staticRenderFns } from "./relatedView.vue?vue&type=template&id=7c639f8e"
import script from "./relatedView.vue?vue&type=script&lang=js"
export * from "./relatedView.vue?vue&type=script&lang=js"
import style0 from "./relatedView.vue?vue&type=style&index=0&id=7c639f8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports